import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { DailyReportColumnDto } from '../../shared/remote-services/dtos/dailyReportColumn.dto'

@Injectable()
export class DailyReportColumnService {
  private http = inject(HttpClient)

  private baseUrl = 'jobsite/dailyreportcolumns'

  public getAll(): Observable<DailyReportColumnDto[]> {
    return this.http.get<DailyReportColumnDto[]>(this.baseUrl)
  }
}
